import { object } from 'common/helpers'


export const initialState = {
  isFetching: false,
  savedItems: {},
  savedItemsIds: [],
  searchResults: [],
}

export const setFetching = (state, payload) => ({
  ...state, isFetching: payload,
})

export const saveItem = (state, { item, status }) => {
  let { savedItemsIds, savedItems } = state
  const { id } = item

  if (savedItemsIds.indexOf(id) === -1) {
    savedItemsIds = [ id, ...savedItemsIds ]
  }

  savedItems = object.set(savedItems, id, { ...item, status })

  return { ...state, savedItems, savedItemsIds }
}

export const setSearchResults = (state, payload) => ({
  ...state, isFetching: false, searchResults: payload,
})

export const reset = () => initialState
